const CachedKeys = {
  //* Modem
  MODEM_INUSED_PORT_LIST: 'MODEM_INUSED_PORT_LIST',
  REFETCH_MODEM_LIST_OPTION: 'REFETCH_MODEM_LIST_OPTION',
  REFETCH_LIST_MODEM: 'REFETCH_LIST_MODEM',
  REFETCH_LIST_COUNT: 'REFETCH_LIST_COUNT',
  MODEM_LIST: 'MODEM_LIST',

  DATA_VENDORS: 'DATA_VENDORS',

  REFETCH_SEQUENCE_LIST: 'REFETCH_SEQUENCE_LIST',
  REFETCH_PROCESS_LIST: 'REFETCH_PROCESS_LIST',

  //* Orders
  REFETCH_LIST_SIM: 'REFETCH_LIST_SIM',
  REFETCH_DETAIL_ORDER: 'REFETCH_DETAIL_ORDER',
  REFETCH_LIST_ORDERS: 'REFETCH_LIST_ORDERS',
  ORDER_ID: 'ORDER_ID',

  //* Route
  REFETCH_LIST_ROUTE: 'REFETCH_LIST_ROUTE',
  CACHED_ROUTE_DETAIL: 'CACHED_ROUTE_DETAIL',
  REFETCH_ROUTE_DETAIL: 'REFETCH_ROUTE_DETAIL',
  IS_EDIT_ROUTE: 'IS_EDIT_ROUTE',
  IS_ENABLE_BCC_SIZE: 'IS_ENABLE_BCC_SIZE',
  IS_VIEW_ONLY_ROUTE: 'IS_VIEW_ONLY_ROUTE',
  ROUTE_PROCESSING: {
    PROCESSING: 'ROUTE_PROCESSING',
    REFETCH_PROCESSING: 'REFETCH_ROUTE_PROCESSING',
  },

  //* Vendor
  CACHED_SERVICE_VENDOR: 'CACHED_SERVICE_VENDOR',
  CACHED_VERTICAL: 'CACHED_VERTICAL',

  LIST_VENDOR: 'LIST_VENDOR',
  LIST_SERVICES: 'LIST_SERVICES',
  LIST_SERVICES_NONE_ROUTES: 'LIST_SERVICES_NONE_ROUTES',
  LIST_VENDOR_DEFAULT_PRICE_GROUPED: 'LIST_VENDOR_DEFAULT_PRICE_GROUPED',
  LIST_VENDOR_UNREGISTERED: 'LIST_VENDOR_UNREGISTERED',
  LIST_SERVICES_BY_VENDOR_ID: (key) => `LIST_SERVICES_BY_VENDOR_ID_${key}`,

  //* Version Management
  HTML_CONTENT: 'HTML_CONTENT',
  REFETCH_LIST_CAROUSEL: 'REFETCH_LIST_CAROUSEL',
  CACHED_LIST_SRC: 'CACHED_LIST_SRC',
  RECENT_UPLOAD_MEDIA: 'RECENT_UPLOAD_MEDIA',

  //* AUDIO
  REFETCH_AUDIO_LIST: 'REFETCH_AUDIO_LIST',
  SET_DATA_AUDIO_LIST: 'SET_DATA_AUDIO_LIST',
  REFETCH_SAMPLE_AUDIO_WITH_VOICE_ID: (voiceId) => `REFETCH_SAMPLE_AUDIO_WITH_VOICE_ID_${voiceId}`,
  SET_DATA_SAMPLE_WITH_VOICE_ID: (voiceId) => `SET_DATA_SAMPLE_WITH_VOICE_ID${voiceId}`,

  //* TenDLC
  LIST_VENDOR_TENDLC: 'LIST_VENDOR_TENDLC',
  REFETCH_BRAND_DETAIL: 'REFETCH_BRAND_DETAIL',
  REFETCH_USECASE_DETAIL: 'REFETCH_USECASE_DETAIL',

  //* TFN
  LIST_VENDOR_TFN: 'LIST_VENDOR_TFN',
  REFETCH_TFN_REQUEST_LIST: 'REFETCH_TFN_REQUEST_LIST',
  REFETCH_TFN_REQUEST_PROCESS_BY_KEY: (key) => `REFETCH_TFN_REQUEST_PROCESS_BY_KEY_${key}`,

  //* NUMBER_POOL
  REFETCH_LIST_NUMBER_POOL: 'REFETCH_LIST_NUMBER_POOL',

  //* SUBSCRIPTION
  SUBSCRIPTION_VIEW_ONLY: 'SUBSCRIPTION_VIEW_ONLY',
  NONE_ROUTE_PRICE_TABLE: 'NONE_ROUTE_PRICE_TABLE',

  //* DID
  REFETCH_SEARCH_DID: 'REFETCH_SEARCH_DID',

  //* MARKETPLACE
  MARKET_PLACE_VIEW_DETAIL: 'MARKET_PLACE_VIEW_DETAIL',
};

export const CampaignComposeKey = {
  REFETCH_SEARCH_CONTACT_GROUPS: 'REFETCH_SEARCH_DEVICE_GROUPS',
  CONTACT_GROUPS: 'CONTACT_GROUPS',
  REFETCH_ANIS_EACH_ROW_MONITORING_BY_CPID: (cpId) =>
    `REFETCH_ANIS_EACH_ROW_MONITORING_BY_CPID_${cpId}`,
  REFETCH_ANIS_DETAI_HISTORY_BY_CPID: (cpId) => `REFETCH_ANIS_DETAI_HISTORY_BY_CPID${cpId}`,
};

export const MappingKey = {
  REFETCH_UNKNOWN_MNC_MCC: 'REFETCH_UNKNOWN_MNC_MCC',
  REFETCH_KNOWN_MNC_MCC: 'REFETCH_KNOWN_MNC_MCC',
};

export const FinanceKey = {
  REFETCH_FINANCE_SHEET: 'REFETCH_FINANCE_SHEET',
};

export default CachedKeys;
